import { RouteConfig } from 'vue-router';
const Home = () => import('./views/home.vue');
const Help = () => import('./views/help.vue');
const Setting = () => import('./views/setting.vue');
const QaList = () => import('./views/qa-list.vue');
const ClassList = () => import('./views/class-list.vue');
const ClassStudent = () => import('./views/class-student.vue');
const TextbookFolder = () => import('./views/textbook-folder.vue');
const TextbookEdit = () => import('./views/textbook-edit.vue');
const TextbookResources = () => import('./views/textbook-resources.vue');
const ResourceShixunEdit = () => import('./views/resource-shixun-edit.vue');
const ResourceZhenciEdit = () => import('./views/resource-zhenci-edit.vue');
const ResourceFolder = () => import('./views/resource-folder.vue');
const ResourceChart = () => import('./views/resource-chart.vue');
const ExamList = () => import('./views/exam-list.vue');
const ExamPaper = () => import('./views/exam-paper.vue');
const ExamPaperEdit = () => import('./views/exam-paper-edit.vue');
const ExamPaperPreview = () => import('./views/exam-paper-preview.vue');
const ExamStatistic = () => import('./views/exam-statistic.vue');
const ExamResult = () => import('./views/exam-result.vue');
const ExamCondition = () => import('./views/exam-condition.vue');
const routers: RouteConfig[] = [
    {
        path: 'home',
        component: Home,
    },
    {
        path: 'help',
        component: Help,
    },
    {
        path: 'setting',
        component: Setting,
    },
    {
        path: 'qa-list',
        component: QaList,
    },
    {
        path: 'class-list',
        component: ClassList,
    },
    {
        path: 'class-student',
        component: ClassStudent,
    },
    {
        path: 'textbook-folder',
        component: TextbookFolder,
    },
    {
        path: 'textbook-edit',
        component: TextbookEdit,
    },
    {
        path: 'textbook-resources',
        component: TextbookResources,
    },
    {
        path: 'resource-folder',
        component: ResourceFolder,
    },
    {
        path: 'resource-shixun-edit',
        component: ResourceShixunEdit,
    },
    {
        path: 'resource-zhenci-edit',
        component: ResourceZhenciEdit,
    },
    {
        path: 'resource-chart',
        component: ResourceChart,
    },
    {
        path: 'exam-list',
        component: ExamList,
    },
    {
        path: 'exam-paper',
        component: ExamPaper,
    },
    {
        path: 'exam-paper-edit',
        component: ExamPaperEdit,
    },
    {
        path: 'exam-paper-preview',
        component: ExamPaperPreview,
    },
    {
        path: 'exam-statistic',
        component: ExamStatistic,
    },
    {
        path: 'exam-result',
        component: ExamResult,
    },
    {
        path: 'exam-condition',
        component: ExamCondition,
    },
];
export default routers;
